import React, { useState } from "react";
import "./Login.css"; 
import { FiEye, FiEyeOff } from "react-icons/fi";
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";
import { NavLink, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../Service.js";
import { UserType } from "../DropdownOptions.js";
import Loading from "../Templates/Loading.js";

const server_url = API_BASE_URL;

const Login = () => {
  const navigate = useNavigate();
  const [type, setType] = useState("password");
  const [icon, setIcon] = useState(FiEyeOff);
  const [email, setEmail] = useState(""); // State for storing email
  const [password, setPassword] = useState(""); // State for storing password
  const [isLoading, setIsLoading] = useState(false);
  // Once auth succeeds we hide the form entirely and show a redirect screen, so
  // the cleared email/password fields never flash before navigation.
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleToggle = () => {
    if (type === "password") {
      setType("text");
      setIcon(FiEye);
    } else {
      setType("password");
      setIcon(FiEyeOff);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    try {
      const response = await fetch(server_url + "login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email_id: email, Password: password }),
      });

      const fetchedResponse = await response.json();

      if (response.status === 200) {
        localStorage.setItem("token", JSON.stringify(fetchedResponse.token));
        localStorage.setItem("UserType", fetchedResponse?.UserType || null);
        localStorage.setItem("userId", JSON.stringify(fetchedResponse?.userId));

        // Clear the credentials and swap the form out for a redirect screen in
        // the same render, then navigate. No delay means no flicker.
        setEmail("");
        setPassword("");
        setIsRedirecting(true);
        toast.success("Login Successful!");
        navigate("/main/board");
      } else {
        toast.error(`Login Failed. ${fetchedResponse.message} `);
        setIsLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      console.error("Error:", error);
      setIsLoading(false);
    }
  };

  if (isRedirecting) {
    return (
      <section style={{ height: "100%" }} className="login-container">
        <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: "100vh", gap: "16px" }}>
          <img src="/namelogo.png" style={{ width: "12em", borderRadius: "8px" }} alt="Kinetika ALM" />
          <p className="h5" style={{ color: "#1d3557", margin: 0 }}>Signing you in…</p>
          <Loading show={true} />
        </div>
      </section>
    );
  }

  return (
    <section style={{ height: "100%" }} className="login-container">
      <div className="container-fluid vh-100">
        <div className="row vh-100">
          {/* Left Column */}
          <div className="vh-100 col-md-10 d-flex flex-column justify-content-center align-items-center" >
          <img
                    src="/namelogo.png"
                    className="img-fluid"
                    style={{ width: "15em", margin: "0 auto 20px",borderRadius:"8px" }}
                    alt="Placeholder"
                  />
            <form
              className="d-flex flex-column mb-0 form-width pt-5"
              onSubmit={handleSubmit} // Add onSubmit handler
              style={{backgroundColor:"#fff", borderRadius:"8px", padding:"20px"}}
            >
              <p className="bolder h5 mt-2">Welcome back!</p>
              <p className="sub-para">Login to Kinetika ALM.</p>
              <hr />
              <label htmlFor="email" className="text-start mb-2 mt-3">
                Email
              </label>
              <input
                type="email"
                placeholder="Enter email"
                className="form-control mb-2"
                id="email"
                value={email} // Set the value from state
                onChange={(e) => setEmail(e.target.value)} // Update state on change
                required
              />
              <label htmlFor="password" className="text-start mb-2">
                Password
              </label>
              <div className="password_input">
                <input
                  type={type}
                  placeholder="Enter password"
                  id="password"
                  className="form-control mb-2"
                  value={password} // Set the value from state
                  onChange={(e) => setPassword(e.target.value)} // Update state on change
                  required
                />
                <span onClick={handleToggle} style={{ cursor: "pointer", top:"45%" }}>
                  {type === "password" ? (
                    <FiEyeOff size={20} />
                  ) : (
                    <FiEye size={20} />
                  )}
                </span>
              </div>
              <strong className="text-end">
                <NavLink to={"/forgot-password"}>Forgot password?</NavLink>
              </strong>

              <button
                type="submit"
                style={{ backgroundColor: "#1d3557" }}
                className="btn btn-primary mt-4 mb-2"
              >
                Login
              </button>

            </form>
          </div>

        </div>
      </div>
      {/* Toast Container to show toasts */}

      {isLoading && <Loading show={isLoading} /> }
    </section>
  );
};

export default Login;
